import {gql} from '@apollo/client';

export const GET_ACCOUNT_QUERY = gql`
	query ($locale: LanguagesCamelType!) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryLogo
				secondaryLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getClientSelf {
			fullName
			email
			image
			clientType
		}
	}
`;

export const GET_CLIENT_SELF_QUERY = gql`
	query {
		getClientSelf {
			fullName
			telNumber
			clientType
			email
			image
		}
	}
`;

export const GET_CLIENT_WITH_CART_WISHLIST_SELF_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
		$currency: String!
		$cart: [MergeClientCartInput!]!
		$wishlist: [MergeClientWishlistInput!]!
	) {
		getClientWithCartWishlistSelf(
			locale: $locale
			currency: $currency
			cartWishlist: {
				cart: $cart
				wishlist: $wishlist
			}
		) {
			fullName
			email
			image
			clientType
			cart {
				quantity
				product {
					id
					alt
					title
					coverImage
					discount
					tag
					prices {
						currencyObj {
							title
							symbol
							left
						}
						overprice
						price
						wholesalePrice
					}
				}
			}
			wishlist {
				product {
					id
					alt
					title
					coverImage
					discount
					tag
					prices {
						currencyObj {
							title
							symbol
							left
						}
						overprice
						price
						wholesalePrice
					}
				}
			}
		}
	}
`;

export const UPDATE_CLIENT_CART_SELF_QUERY = gql`
	mutation (
		$action: ActionType!
		$productId: Int!
		$quantity: Int!
		$staticQuantity: Boolean = false
	) {
		updateClientCartSelf(
			data: {
				action: $action
				productId: $productId
				quantity: $quantity
				staticQuantity: $staticQuantity
			}
		)
	}
`;

export const UPDATE_CLIENT_WISHLIST_SELF_QUERY = gql`
	mutation (
		$liked: Boolean!
		$productId: Int!
	) {
		updateClientWishlistSelf(
			data: {
				liked: $liked
				productId: $productId
			}
		)
	}
`;

export const GET_CLIENT_CART_SELF_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
		$currency: String!
	) {
		getClientCartsSelf(
			locale: $locale
			currency: $currency
		) {
			quantity
			product {
				id
				alt
				title
				coverImage
				discount
				status
				tag
				quantity
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
			}
		}
		getAutoUseCoupon(locale: $locale) {
			title
			discount
			value
		}
		getActualPricePolicyForClient(currency: $currency) {
			fromPrice
			discount
		}
	}
`;

export const GET_CLIENT_WISHLIST_SELF_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
		$currency: String!
	) {
		getClientWishlistSelf(
			locale: $locale
			currency: $currency
		) {
			product {
				id
				alt
				title
				coverImage
				discount
				tag
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
			}
		}
	}
`;

export const GET_CLIENT_ORDERS_SELF_QUERY = gql`
	query {
		getClientOrders {
			uid
			status
			totalComputed {
				totalPrice
			}
			currencyObj {
				title
				symbol
				left
			}
			delivery
			deliveryPrice
			createdAt
		}
	}
`;

export const GET_CLIENT_ORDER_SELF_QUERY = gql`
	query(
		$uid: String!
		$locale: LanguagesCamelType!
	) {
		getClientOrder(
			uid: $uid
			locale: $locale
		) {
			uid
			status
			items {
				product {
					alt
					title
					coverImage
				}
				quantity
				price
				discount
				discountType
			}
			branch {
				title
				address
			}
			paymentComputed {
				amount
			}
			paymentType
			notes
			reason
			coupon {
				title
			}
			createdAt
			currencyObj {
				title
				symbol
				left
			}
			delivery
			deliveryPrice
			deliveryAddress
			totalComputed {
				baseTotalPrice
				totalPrice
				count
				totalQuantity
			}
		}
	}
`;

export const GET_PRODUCT_REVIEWS_SELF_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
	) {
		getProductReviewsSelf(
			locale: $locale
		) {
			product {
				id
				alt
				title
				coverImage
			}
			value
			comment
			repliesCount {
				count
			}
			createdAt
		}
	}
`;

export const UPDATE_CLIENT_SELF_QUERY = gql`
	mutation (
		$fullName: String
		$telNumber: String
		$email: String
		$currentPassword: String
		$newPassword: String
	) {
		updateClientSelf(
			data: {
				fullName: $fullName
				telNumber: $telNumber
				email: $email
				currentPassword: $currentPassword
				newPassword: $newPassword
			}
		)
	}
`;

export const UPDATE_CLIENT_ADDRESS_SELF_QUERY = gql`
	mutation (
		$address: String!
	) {
		updateClientAddressSelf(
			address: $address
		)
	}
`;

export const UPDATE_CLIENT_SELF_IMAGE_QUERY = gql`
	mutation ($file: Upload!) {
		updateClientSelfImage(file: $file)
	}
`;

export const DELETE_CLIENT_SELF_IMAGE_MUTATION = gql`
	mutation {
		deleteClientSelfImage
	}
`;

export const GET_CLIENT_ADDRESS_BRANCHES_QUERY = gql`
	query ($locale: LanguagesCamelType!) {
		getClientSelf {
			address
		}
		getBranchesForClient(locale: $locale) {
			title
			address
			telNumber
		}
	}
`;

export const CHECK_COUPON_MUTATION = gql`
	mutation (
		$locale: LanguagesCamelType!
		$code: String!
	) {
		checkCoupon(
			locale: $locale
			code: $code
		) {
			coupon {
				title
				discount
				value
			}
			error
		}
	}
`;

export const GET_CHECKOUT_SELF_QUERY = gql`
	query(
		$locale: LanguagesCamelType!
		$currency: String!
	) {
		getStoreCommonConfig(locale: $locale) {
			home {
				location
				shopBackgroundImage
				primaryLogo
				secondaryLogo
			}
			contact {
				email
				telNumber
				whatsapp
				telegram
			}
			socialLinks {
				title
				icon
				url
			}
			currencies {
				title
				symbol
				main
				left
			}
		}
		getClientSelf {
			fullName
			telNumber
			clientType
			email
			address
		}
		getClientCartsSelf(
			locale: $locale
			currency: $currency
		) {
			quantity
			product {
				id
				alt
				title
				coverImage
				discount
				status
				tag
				quantity
				prices {
					currencyObj {
						title
						symbol
						left
					}
					overprice
					price
					wholesalePrice
				}
			}
		}
		getAutoUseCoupon(locale: $locale) {
			title
			discount
			value
		}
		getActualPricePolicyForClient(currency: $currency) {
			fromPrice
			discount
		}
		getBranchesForClient(locale: $locale) {
			id
			title
			address
		}
	}
`;

export const CREATE_ORDER_QUERY = gql`
	mutation (
		$items: [CreateOrderItemInput!]!
		$branchId: Int
		$couponCode: String
		$currency: String!
		$delivery: DeliveryInput
		$notes: String
		$paymentType: PaymentType!
		$locale: LanguagesLowerType!
		$clientTelNumber: String
		$clientFullName: String
	) {
		createOrder(
			data: {
				items: $items
				branchId: $branchId
				couponCode: $couponCode
				currency: $currency
				delivery: $delivery
				notes: $notes
				paymentType: $paymentType
				clientFullName: $clientFullName
				clientTelNumber: $clientTelNumber
			}
			locale: $locale
		) {
			uid
		}
	}
`;
